module.exports = __webpack_public_path__ + "assets/img/icon-logo.5098fd48.svg";